import { BotTag } from '../../../../../../../../../utils/Tags'
import { useTw } from '../../../../../../../../../utils/Styles'
import { useSenderInfo } from '../../../../../../../../../utils'
import { ConversationQuery } from '../../../../Conversation.generated'

type MessageType = ConversationQuery['Conversation']['messages'][0]
type SenderProps = { event: MessageType }
type Props = {
  bot?: boolean
  right?: boolean
  sender: { name?: string; title?: string; logoURL?: string }
}

export function OperatorTooltip({ sender, right }: Props) {
  const tw = useTw()
  const data = useSenderInfo({ sender })
  return (
    <div
      className={tw`absolute bottom-12 z-10 w-64 ${
        right ? 'right-0' : 'left-0'
      }`}
    >
      <div
        className={tw`bg-white rounded-lg shadow w-full flex items-center justify-between p-4 space-x-4`}
      >
        <img
          src={data.logoURL}
          alt={`${data.name} Avatar`}
          className={tw`w-10 h-10 bg-white object-cover rounded-full flex-shrink-0`}
        />
        <div className={tw`flex-1 truncate`}>
          <div className={tw`flex items-center space-x-3`}>
            <h3 className={tw`text-gray-900 text-sm font-medium truncate`}>
              {data.name}
            </h3>
            {data?.bot ? <BotTag /> : null}
          </div>
          <p className={tw`mt-1 text-left text-gray-500 text-sm truncate`}>
            {data.title}
          </p>
        </div>
      </div>
    </div>
  )
}

function VisitorTooltip({ sender }: { sender: { name?: string } }) {
  const tw = useTw()
  return (
    <div className={tw`absolute bottom-12 left-0`}>
      <div
        className={tw`px-4 mt-1 py-2 pointer-events-none rounded-lg text-white bg-gray-700 overflow-hidden shadow text-xs text-right whitespace-nowrap`}
      >
        {sender.name}
      </div>
    </div>
  )
}

export function SenderTooltip({ event }: Pick<SenderProps, 'event'>) {
  switch (event.sender.__typename) {
    case 'MemberUser':
      return <OperatorTooltip right sender={event.sender} />

    case 'APIIntegration':
      return <OperatorTooltip bot right sender={event.sender} />

    case 'Visitor':
      return <VisitorTooltip sender={event.sender} />

    default:
      return null
  }
}
